
import Alert from 'vux/src/components/alert/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Datetime from 'vux/src/components/datetime/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'


import loadPage from '../../components/loadingPage'
import global from '../../../static/js/global.js'
import jquery from 'jquery'

export default {
components: {
Selector,
Group,
Cell,
Flexbox,
FlexboxItem,
XTable,
dateFormat,
Confirm,
FormPreview,
Alert,
loadPage,
PopupPicker,
Datetime,
jquery
},
filter:{
dateFormat
},
data(){
return{
username:'',
usertype:'',
district:' 玫瑰苑',
house:'',
flag:'',
accout:'',
comnCode:"",
createDate:'',
houseAreas:'',
show:false,
mlist1:[[{
name: '全部',
value: 'other'
},{
name: '物业费',
value: 'wuye'
},{
name: '车位费',
value: 'park'
},{
name: '水电费',
value: 'water'
}]],
mValue1:['other'],
mValue2:this.getNowFormatMonth(),
allOrder:[],
totalFee:'',
totalSumFee:0,
detailData:[],
detailSuccess:[],
end:'',
start:'',
hsName:'',
hs_no:'',
billCode:'',
showprompt:false,
showDetail:false,
showWaterDetail:false,
showWaterUnpay:false,
prompt:'',
paymonth:'',
giving:'',
paysum:'',
feeType:'',
payDate:'',
carShow:false,
parkInfo:{},
Mtitle:'去支付',
Mclose:'取消订单',
carInfosMessage:'',
show_1:false
}
},
beforeMount(){

if(this.$router.history.current.path == "/paymentRecord"){
document.title = "缴费记录";
}
this.show_1 = true;
/* console.log(this.mlist1[0][0].name)
this.mValue1[0] = this.mlist1[0][0].name;*/
this.$http.get(global.host + 'users/personalCenter?phone=' + this.$router.history.current.query.phone +'&openid=' + this.$router.history.current.query.openid).then(function(res){
if(res.body.result){
console.log(res)
let data = res.body.result[0];
this.username = data.name;
this.usertype = data.type ;


this.houseAreas = data.houseArea;


let mgData = data.parkCode;
let mSms = mgData.toString();
var replaces = ',';
this.carInfosMessage = mSms.replace(new RegExp(replaces,'gm'),'   ')




this.house =  data.hsNo;
this.district = data.comName
this.comnCode = data.comn_code
this.hsName = data.hsName;
this.hs_no = data.hsNo;

this.searchFeeList();
}
},function(err){
console.log(err)
})
},
updated(){
jquery(".mDailog .weui-dialog__bd").css("padding","1.3em 0em 0.5em")
},
methods:{
searchFeeList(){
this.show_1 = true;
this.feeType = this.mValue1[0];
this.payDate = this.mValue2;
console.log("&&&&&&&&&&&&&&&&&&&&&&&&&")
console.log(this.payDate)


this.$http.get(global.host + 'pay/findownerorder?comnCode='+ this.comnCode + '&houseNo=' + this.hs_no +'&phoneNo=' + this.$router.history.current.query.phone +'&openid=' + this.$router.history.current.query.openid + '&feeType='+this.feeType + "&payDate=" +this.payDate ).then(function(res){
let data = res.body;
this.allOrder = [];
let total = 0;
for(let i = 0 ; i < data.length; i++){
this.allOrder.push(data[i]);
total = total + data[i].totalMoney;
}
this.totalSumFee = total.toFixed(2);
this.show_1 = false;
},function(err){
this.show_1 = false;
console.log(err);
});
},
changeFeeType(){
this.searchFeeList();
},
changeFeeDate(){
this.searchFeeList();
},
/*显示已支付和作废的订单详情弹框*/
showOrder(item){
this.show_1 = true;
this.billCode = item.billCode;
this.createDate = item.createDate;
/*清空详情数组中的内容*/
let size = this.detailSuccess.length;
for(let j = 0 ; j < size; j++){
this.detailSuccess.pop();
}
this.$http.get(global.host + 'pay/findunpaiddetail?tradeNo=' + this.billCode).then(function (res) {


this.totalFee = 0;
this.accout = res.body.accountbanlance;
let detail = res.body.result;
if(res.body.orderType=='wuye'){
for (let i = 0; i < detail.length; i++) {
detail[i].start = dateFormat(new Date(detail[i].startDate), 'YYYY/MM');
detail[i].end = dateFormat(new Date(detail[i].endDate), 'YYYY/MM');
this.detailSuccess.push(detail[i]);
this.totalFee = this.totalFee * 1 + detail[i].shishou * 1
}
/*容易出现小数点截取异常*/
this.totalFee = this.totalFee.toFixed(2);
this.showDetail = true;

}else if(res.body.orderType=='water'){
for (let i = 0; i < detail.length; i++) {
this.detailSuccess.push(detail[i]);
this.totalFee = res.body.account;
}
this.showWaterDetail = true;

}else if(res.body.orderType=='park'){
this.carShow = true;
this.parkInfo = res.body.result;
this.totalFee = this.parkInfo.feeMoney;
}
this.show_1 = false;
},function (err) {
console.log(err)
})

},
/*取消订单*/
cancelpay(){
if(this.Mclose == "关闭"){
this.carShow = false;
}else{
this.$http.get(global.host + 'pay/cancelpayorder?tradeNo=' + this.billCode).then(function (res) {
if(res.body.code == '110'){
/*重新加载数据*/
this.feeType = this.mValue1[0];
this.payDate = this.mValue2;
this.$http.get(global.host + 'pay/findownerorder?comnCode='+ this.comnCode + '&houseNo=' + this.hs_no + '&openid=' + this.$router.history.current.query.openid + '&phoneNo=' + this.$router.history.current.query.phone +"&feeType=" +this.feeType + "&payDate=" +this.payDate).then(function(res){
console.log(res)
let data = res.body;
this.allOrder = [];
let total = 0;
for(let i = 0 ; i < data.length; i++){
this.allOrder.push(data[i]);
total = total + data[i].totalMoney;
}
this.totalSumFee = total.toFixed(2);
},function(err){
console.log(err)
});
}else{
this.prompt = '订单取消异常,请稍候再试'
this.showprompt = true;
}
},function(err){
console.log(err)
})
}

},
/*刷新页面*/
refresh(){
if(this.prompt == '支付成功'){
this.submitable = false;
this.$router.push({path:'/paymentRecord',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}})

}else{
this.show = true;
this.submitable = true;
}
},
/*显示未支付订单的详情*/
showpay(item,index,feeType){
this.show_1 = true;
this.billCode = item.billCode
this.createDate = item.createDate
let size = this.detailData.length;
for(let j = 0 ; j < size; j++){
this.detailData.pop();
}

jquery(".mDailog .weui-dialog__bd").css("padding","1.3em 0em 0.5em")
this.$http.get(global.host + 'pay/findunpaiddetail?tradeNo=' + this.billCode).then(function (res) {
console.log(res)


this.totalFee = 0;
this.paymonth = res.body.paymonth;
this.giving = res.body.freemonth
this.paysum = res.body.paysum
let detail = res.body.result;
if(res.body.orderType=='wuye') {
for (let i = 0; i < detail.length; i++) {
detail[i].start = dateFormat(new Date(detail[i].startDate), 'YYYY/MM');
detail[i].end = dateFormat(new Date(detail[i].endDate), 'YYYY/MM');
this.detailData.push(detail[i])
this.totalFee = this.totalFee + detail[i].shishou * 1
}
this.totalFee = (this.totalFee * 1).toFixed(2)
this.accout = (this.accout * 1).toFixed(2)
this.show = true;

}else if(res.body.orderType=='water'){
for (let i = 0; i < detail.length; i++) {
this.detailData.push(detail[i]);
}
this.totalFee = res.body.account;
this.showWaterUnpay = true;

}else if(res.body.orderType=='park'){
this.carShow = true;
this.parkInfo = res.body.result;
this.totalFee = this.parkInfo.feeMoney;
}
this.show_1 = false;
},function (err) {
console.log(err)
})

},
/*去支付*/
gopay(feeType){
this.show_1 = true;
let senddata = new Object();
senddata.comnCode = this.comnCode
/*当账户余额大于0时，调用微信支付的接口*/
if(this.totalFee > 0){
/*调用微信支付的接口*/
senddata.memberNo = this.$router.history.current.query.phone;
senddata.openid = this.$router.history.current.query.openid;
senddata.tradeAmount = this.totalFee
senddata.tradeNo = this.billCode;

senddata.tradeName='物业费';
senddata.tradeDesc='物业费(包括电梯费、生活垃圾费)';
let url = global.host + 'pay/getpayurl';
if(feeType==="park"){
senddata.tradeName='车位费';
senddata.tradeDesc='停车费(临时停车费、车位管理费)';
url = global.host + 'parkFeeBill/getpayurl';
}else if(feeType==="water"){
senddata.tradeName='水电费';
senddata.tradeDesc='水电费(水费、电费)';
url = global.host + 'hydro/getpayurl';
}
this.$http.post(url,senddata).then(function(res){
console.log(res)
if(res.body.code == '110'){
location.href = res.body.payurl;
}else{
this.prompt = '支付异常,请稍候再试'
this.showprompt = true;
}
},function(err){
this.show_1 = false;
console.log(err);
})
}
},
/**
* 获取当前月份
* 格式YYYY-MM
*/
getNowFormatMonth(){
var date = new Date();
var seperator1 = "-";
var year = date.getFullYear();
var month = date.getMonth() + 1;
var strDate = date.getDate();
if (month >= 1 && month <= 9) {
month = "0" + month;
}
if (strDate >= 0 && strDate <= 9) {
strDate = "0" + strDate;
}
return year + seperator1 + month;
}

}
}



// WEBPACK FOOTER //
// ./src/components/payComponents/paymentRecord.vue